import { Card, Panel } from '@/components/Bicester';
import Image from '@/components/Bicester/Image';
import React from 'react';
import { IconButton } from 'rsuite5';
import ExchangedTicketTable from './ExchangedTicketTable';
import ExpiredTicketTable from './ExpiredTicketTable';
import { FormikContextType, FormikProvider } from 'formik';
import { Form } from '@/components/formik-rsuite';
import { DateRangePicker } from 'rsuite';
const { allowedMaxDays } = DateRangePicker;

/**
 * 卡券type
 */
export enum TICKET_TYPE {
  /** 已过期卡券 */
  'EXPIRED' = 1,
  /** 已兑换卡券 */
  'EXCHANGED' = 2,
}
const TicketType = {
  [TICKET_TYPE.EXPIRED]: '已过期卡券',
  [TICKET_TYPE.EXCHANGED]: '已兑换卡券',
};

const ExchangedOrExpiredTicket = ({
  data,
  loading,
  onChange,
  type,
  onSwitch,
  onReSearch,
  exchangedFormik,
}: {
  data: any;
  loading: boolean;
  onChange: (params: any) => void;
  type: TICKET_TYPE;
  onSwitch: (type: TICKET_TYPE) => void;
  onReSearch?: () => void;
  exchangedFormik?: FormikContextType<any>;
}) => {
  const isExchanged = type === TICKET_TYPE.EXCHANGED;

  return (
    <Panel
      leftShadow
      title={
        <IconButton
          className="flex items-center"
          style={{ height: 30 }}
          onClick={() => {
            const nextType = (type + 1) % 2 || 2;
            onSwitch(nextType);
          }}
        >
          <div className="text-[20px]">{TicketType[type]}</div>
          <Image className="mx-[8px]" src="/resources/images/switch.svg" />
          <div className="text-[14px]">{TicketType[(type + 1) % 2 || 2]}</div>
        </IconButton>
      }
      subTitle={`总计 ${(isExchanged ? data?.total : data?.total) || 0} 条`}
      {...(isExchanged && {
        toolbar: (
          <div className="flex justify-end">
            <FormikProvider value={exchangedFormik}>
              <Form style={{ width: 'calc(50% + 150px)' }}>
                <Card smDivider horizontal>
                  <Card.Picker
                    label="购物村"
                    formKey="shopping_village"
                    pickerData={[
                      { label: '全部', value: 0 },
                      { label: '苏州村', value: 1 },
                      { label: '上海村', value: 2 },
                    ]}
                    labelWeight={1}
                    contentWeight={2}
                  />
                  <Card.DateRangePicker
                    label="兑换时间"
                    formKey="time_range"
                    placement="bottomEnd"
                    disabledDate={allowedMaxDays(30)}
                    labelWeight={1}
                    contentWeight={2}
                  />
                  <IconButton
                    type="submit"
                    className="flex items-center w-[30px] ml-[10px]"
                    style={{ height: 47 }}
                  >
                    <Image src="/resources/images/match.svg" />
                  </IconButton>
                </Card>
              </Form>
            </FormikProvider>
          </div>
        ),
      })}
    >
      {isExchanged ? (
        <ExchangedTicketTable
          data={data?.content_list || []}
          page={data?.current_page}
          total={data?.total}
          onChange={onChange}
          onReSearch={onReSearch}
          loading={loading}
        />
      ) : (
        <ExpiredTicketTable
          data={data?.content_list || []}
          page={data?.current_page}
          total={data?.total}
          onChange={onChange}
          loading={loading}
        />
      )}
    </Panel>
  );
};

export default ExchangedOrExpiredTicket;
